import React, { useState, useEffect } from "react";
import { domain } from "../auth/domain";
import Popup from "../components/staffsDialog";
import swal from "sweetalert";
import userImg from "../assets/img/user.jpg";
import NoRecords from "../shared/NoRecords";
import {
  LinearProgress,
  Box,
  Paper,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  InputAdornment,
  Button,
} from "@mui/material";
import { MoreVert, Search } from "@mui/icons-material";

function Staffs() {
  const accessToken = localStorage.getItem("accessToken");
  const [staffs, setStaffs] = useState([]);
  const [filteredStaffs, setFilteredStaffs] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [showSpinner, setShowSpinner] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [refreshTable, setRefreshTable] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedStaff, setSelectedStaff] = useState(null);

  const handleMenuClick = (event, staff) => {
    setAnchorEl(event.currentTarget);
    setSelectedStaff(staff);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  // handle react page visibility based on open/clode of popup
  const handleToggleModal = (modalState) => {
    setIsModalOpen(modalState);
  };

  const handleTableRefresh = (info) => {
    setRefreshTable(info);
  };

  // Implement a function to handle the search functionality
  const handleSearch = (event) => {
    const query = event.target.value.toLowerCase();
    const filtered = staffs.filter(
      (staff) =>
        staff.full_name.toLowerCase().includes(query) ||
        staff.email.toLowerCase().includes(query)
    );
    setFilteredStaffs(filtered);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDeleteStaff = async (userId) => {
    try {
      const result = await swal({
        title: "Are you sure you want to Delete this user ?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });

      if (result) {
        const response = await fetch(domain + "auth/users/" + userId + "/", {
          method: "DELETE",
          headers: {
            Authorization: "JWT " + accessToken,
          },
        });

        if (response.ok) {
          swal({
            title: "success",
            text: "User successful deleted",
            icon: "success",
            buttons: false,
            timer: 2000,
          });
          handleMenuClose();
          handleTableRefresh(Math.random());
        } else {
          const body = await response.json();
          const details = body?.detail;
          swal({
            title: "Failed",
            text: details ? details : "Error occured",
            icon: "error",
            buttons: false,
            timer: 2000,
          });
        }
      }
    } catch (error) {}
  };

  // Fetch Current staffs
  const fetchStaffs = () => {
    setShowSpinner(true);
    fetch(domain + "auth/users/", {
      method: "GET",
      headers: {
        Authorization: "JWT " + accessToken,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setStaffs(data);
        setFilteredStaffs(data);
        setShowSpinner(false);
      })
      .catch((error) => console.error(error))
      .finally(() => setShowSpinner(false));
  };

  useEffect(() => {
    setShowSpinner(true);
    fetchStaffs();
  }, [refreshTable]);

  return (
    <Box sx={{ width: "100%" }}>
      {showSpinner && <LinearProgress />}
      <Paper sx={{ width: "100%", mb: 2, p: 2 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}>
          <Typography variant="h6" component="div">
            Users
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <TextField
              size="small"
              placeholder="Search..."
              onChange={handleSearch}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
              }}
              sx={{ mr: 2 }}
            />
            <Popup
              onToggleModal={handleToggleModal}
              onRefreshTable={handleTableRefresh}
              formTitle={"Add User"}
              btnName={"ADD"}
            >
              <Button
                variant="contained"
                color="primary"
                startIcon={<i className="fa fa-plus"></i>}
              >
                Add User
              </Button>
            </Popup>
          </Box>
        </Box>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Full Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell>Phone Number</TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Branch</TableCell>
                <TableCell align="right">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(rowsPerPage > 0
                ? filteredStaffs.slice(
                    page * rowsPerPage,
                    page * rowsPerPage + rowsPerPage
                  )
                : filteredStaffs
              ).map((staff, index) => (
                <TableRow hover key={staff.id}>
                  <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <img
                        width="28"
                        height="28"
                        src={userImg}
                        className="rounded-circle m-r-5"
                        alt=""
                      />
                      {staff?.full_name}
                    </Box>
                  </TableCell>
                  <TableCell>{staff.email}</TableCell>
                  <TableCell>{staff?.phone_number}</TableCell>
                  <TableCell>{staff?.groups?.name}</TableCell>
                  <TableCell>{staff?.my_branch?.name}</TableCell>
                  <TableCell align="right">
                    <IconButton onClick={(event) => handleMenuClick(event, staff)}>
                      <MoreVert />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <NoRecords data={staffs} />
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredStaffs.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <Popup
          onToggleModal={handleToggleModal}
          onRefreshTable={handleTableRefresh}
          formTitle={"Update User"}
          userId={selectedStaff?.id}
          onCloseMenu={handleMenuClose}
          btnName={"Edit"}
        >
          <MenuItem>
            <i className="fa fa-pencil m-r-5"></i> Edit
          </MenuItem>
        </Popup>
        <MenuItem onClick={() => handleDeleteStaff(selectedStaff?.id)}>
          <i className="fa fa-trash-o m-r-5"></i>
          Delete
        </MenuItem>
      </Menu>
    </Box>
  );
}

export default Staffs;
